import React, { useEffect, useState, useContext } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button, InputLabel } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { BASE_URL } from "../../../constants.tsx";
import Tabs from "@material-ui/core/Tabs";
import { useHistory, useLocation } from "react-router";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import HeaderMenu from "../../../Components/HeaderMenu";
import BannerImage from "../../../Images/TealCRFbanner.png";
import Paper from "@material-ui/core/Paper";
import DataService from "../../../Service";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select/Select";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import { useParams } from "react-router-dom";
import DataClient from "../../../Service/general_data_service";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import MenuItem from "@material-ui/core/MenuItem";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Fab from "@material-ui/core/Fab";
import Zoom from "@material-ui/core/Zoom";
import { useSelector, useDispatch } from "react-redux";
import useHideOnScrolled from "../../../Components/UseHideOnScrolled";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Autocomplete from "@material-ui/lab/Autocomplete";

const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
    textTransform: "none",

    // justifyContent:'space-around'
  },
  // indicator: {
  //   backgroundColor: "#1890ff",
  // },
})(Tabs);

const useStyles = makeStyles((theme) => ({
  root1: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(10),
  },
  root: {},
  bannerStyle: {
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1301,
    position: "sticky",
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    width: "80.6%",
    marginTop: "-125px",
    zIndex: 1301,
    position: "fixed",
  },
  tabs: {
    color: "rgb(30,30,30)",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: " rgba(7,127,131,0.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    fontSize: 14,
    minWidth: 130,
    textTransform: "none",
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    },
  },
  statsBoard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    width: "17%",
    borderLeft: "solid #3B86FF",
  },
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
  stepperButtons: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "3%",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
  demo2: {
    position: "relative",

    paddingTop: "100px",
    padding: "20px",
    zIndex: 1,
  },
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ paddingTop: "30px", padding: "25px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
let sectionId = "";
let crfFromId = "";
function a11yProps(index, item) {
  sectionId = item.id;
  crfFromId = item.coaching_request_form_id;
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}
export default function CustomizedTabs() {
  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = React.useState(0);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [CoachinRequest, setCrfSection] = useState([]);
  const [crfDescription, setCrfDescription] = useState("");
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [userData, setUserData] = useState();
  const [radioValue, seRadioValue] = useState("");

  const [orgLogo, setOrgLogo] = useState("");
  const [prgName, setPrgName] = useState("");
  const [currentSelectionField, setCurrentSelectionField] = useState({});
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [crfValue, setCrfValue] = useState([]);
  const [inputStateVal, setInputStateVal] = useState(null);
  const [totalCount, setTotalCount] = useState(100);
  const [crfUserId, setCrfUserId] = useState("");
  const [crfFormId, setCrfFormId] = useState("");
  const [crfId, setCrfId] = useState("");
  let { slug } = useParams();
  const [answerData, setAnswerData] = useState({});
  let quesArr = [];

  const handleChange = (event, newValue) => {
    // console.log("answerData", answerData);

    if (
      Object.entries(answerData).length === 0 &&
      answerData.constructor === Object
    ) {
      setValue(newValue);
    } else {
      setAnswerData({});
      setValue(newValue);
    }
    window.scroll({ top: 0 });
  };
  const handleradioChange = (event) => {
    seRadioValue(event.target.value);
  };

  // const handleUpdate = (formData) => {
  //   setLoading(true);
  //   const statusData = {
  //     service_type: "External",
  //     approval_required: radioValue,
  //   };
  //   DataClient.update(statusData, `/coaching_request_forms/${crfId}`)
  //     .then((res) => {
  //       if (res) {
  //         dispatch(showSnackbar("success", ["Success!"]));
  //       } else {
  //         setSubmitClickFlag(true);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       dispatch(showSnackbar("error", [["" + err.errors]]));
  //     });
  // };
  const urlParams =
    typeof window !== `undefined` &&
    new URLSearchParams(window.location.search);
  const bodyParameters = {
    key: "value",
  };

  const handleChangeData = (fieldId) => {};
  const setInputState = (inputStateValue, inputId) => {
    // console.log(`object`, inputStateValue, inputId);
    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const setQuestionChangeState = (selectedItemValue, inputId) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    setAnswerData({
      ...answerData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    inputId == "Business Experience" &&
      setUserData({ ...userData, ref4: selectedItemValue.value });
  };

  // const Programmes = () => {
  //   const statusData = {
  //     organisation_id: orgId,
  //   };
  //   DataService.getDirectData(
  //     `coaching_request_forms/listing_programme`,
  //     statusData
  //   ).then((res) => {
  //     setTotalCount(res["total_count"]);
  //     // if(res.success){
  //     if (res.programmes && res.programmes.length > 0) {
  //       let CoachinRates = res.programmes;
  //       setModuleSetups(CoachinRates);
  //     }
  //     setLoading(false);
  //   });
  // };
  // console.log("CoachinRates", CoachinRequest);
  const CrfFetch = () => {
    DataService.getDirectData(`/coaching_request_forms/${slug}`)
      .then((res) => {
        // if(res.success){
        // console.log(`res.id`, res.id);
        setCrfId(res.coaching_request_form.id);
        let CoachinRequests = res.coaching_request_form.crf_form_sections;
        let orgLogo = res.coaching_request_form.org_logo;
        let prgName = res.coaching_request_form.programme_name;
        let description = res.coaching_request_form.description;
        let filterCoach = CoachinRequests?.filter(
          (selected_field) => selected_field.section_name !== "Description"
        );
        setOrgLogo(orgLogo);
        setCrfSection(CoachinRequests);
        setCrfDescription(description);
        setPrgName(prgName);
        localStorage.clear();
        // setLoading(false);
      })
      .catch((err) => {
        console.log("object :>> err ", err);
        history.push({ pathname: `/otheruserlogin` });
        localStorage.clear();
      });
  };
  const FetchCrfAnswer = () => {
    const statusData = {
      coaching_request_form_id: crfFromId,
      crf_user_id: crfUserId || "",
    };

    DataService.getDirectData(`/crf_users/view_crf`, statusData).then((res) => {
      // if(res.success){
      let crfAnswer = res;
      let CoachinRequests = res.coaching_request_form.crf_form_sections;

      setCrfSection(CoachinRequests);
    });
  };

  useEffect(() => {
    // setLoading(true);
    CrfFetch();
    // Programmes();
    // FetchCrfAnswer()
  }, []);

  const hidden = useHideOnScrolled();
  const [open, setOpen] = React.useState(false);
  const [empData, setEmpData] = useState([]);
  const [empValue, setEmpValue] = React.useState("");
  const [empDetail, setEmpDetail] = React.useState({});
  const [PrgValue, setPrgValue] = React.useState("");
  const [empInputValue, setEmpInputValue] = React.useState("");
  const globaluserData = useSelector((state) => state.commonReducer);
  // const orgId = localStorage.getItem("organisation_id");
  const orgId = globaluserData.userData.organisation_id;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  // const employeeKeys = {
  //   "Home based location (City/Country)": "home_city",
  //   Level: "level_or_grade",
  //   Grade: "level_or_grade",
  //   Band: "level_or_grade",
  //   Mobile: "mobile",
  //   "Office city": "office_city",
  //   "Office country": "office_country",
  //   "Home city": "home_city",
  //   "Home country": "home_country",
  //   "PA Name": "pa_name",
  //   // "PA contact details": "pa_contact_details",
  //   "Email address": "primary_email",
  //   Telephone: "telephone",
  //   Name: "coahee_name",
  //   "Job Title": "job_title",
  //   "Job title": "job_title",
  //   Role: "job_role",
  //   "Line manager name": "line_manager_name",
  //   "Name of Line Manager": "line_manager_name",
  //   "Line manager title": "line_manager_title",
  //   "Line manager contact details": "line_manager_contact_details",
  //   "LOB leader": "lob_leader",

  //   "HR sponsor contact details": "hr_sponsor_contact_details",
  //   "HR sponsor name": "hr_sponsor_name",
  //   "HR sponsor title": "hr_sponsor_title",
  //   "PA contact details": "pa_contact_details",
  //   "LOB leader name": "lob_leader_name",
  //   "Line manager PA contact details": "line_manager_pa_contact_details",
  //   "Line manager PA name": "line_manager_pa_name",
  // };
  const employeeKeys = {
    // home_based_location: "home_city",
    // level: "level_or_grade",
    //
    // contact_details_phone_number: "mobile",
    // location: "office_city",
    "Office country": "office_country",
    home_based_location: "home_address",
    level: "level_or_grade",

    contact_details_phone_number: "mobile",
    location: "office_address",
    "office_based_location_(city/country)": "office_address",
    // "Home city": "home_city",
    "Home country": "home_country",
    "PA Name": "pa_name",
    pa_email_address: "pa_contact_details",
    "People partner email address": "people_partner_email_address",
    "Human capital partner email address":
      "human_capital_partner_email_address",
    line_manager_email_address: "line_manager_contact_details",
    contact_details_email: "primary_email",
    contact_details_telephone_number: "telephone",
    name_of_human_capital_partner: "hr_sponsor_name",
    name_of_people_partner: "hr_sponsor_name",
    people_partner_email_address: "hr_sponsor_contact_details",
    // Name: "coahee_name",
    // "Job Title": "job_title",
    // // "Job title": "job_title",
    // "Role": "job_role",
    line_manager_name: "line_manager_name",
    // "Line manager title": "line_manager_title",
    // "Line manager contact details": "line_manager_contact_details",
    // "LOB leader": "lob_leader",

    human_capital_partner_email_address: "hr_sponsor_contact_details",
    // "HR sponsor name": "hr_sponsor_name",
    // "Name of HRBP":"hr_sponsor_name",
    // "Name of People Partner": "hr_sponsor_name",
    // "HR sponsor title": "hr_sponsor_title",
    // "PA contact details": "pa_contact_details",
    lob_leader: "lob_leader_name",
    // "Line manager PA contact details": "line_manager_pa_contact_details",
    // "Line manager PA name": "line_manager_pa_name"
  };
  const getData = () => {
    // setLoading(true);
    if (orgId) {
      const params = {
        organisation_id: orgId,
        // organisation_id: (value !== null || organisationId) ? value.id ||organisationId : null || null
      };
      DataService.getDirectData(`/coaching_request_forms/employee_list`, params)
        .then((response) => {
          let listData = response["employees"];
          setEmpData(listData);
          setLoading(false);
        })

        .catch((err) => {});
    }
    // setLoading(true);
    if (empValue !== "") {
      const params1 = {
        employee_id: empValue.id,
      };
      DataService.getDirectData(
        `/coaching_request_forms/employee_detail`,
        params1
      )
        .then((response) => {
          if (empInputValue) {
            let listData = response.employee_detail;
            setEmpDetail(listData);
            setLoading(false);
            let aswerFileds = {};
            aswerFileds[inputStateVal] =
              empValue.id !== undefined ? empValue.id.toString() : empValue.id;
            CoachinRequest?.filter(
              (selected_field) => selected_field.section_name !== "Description"
            )[value].crf_fields.map((row) => {
              if (
                Object.keys(employeeKeys).includes(row.field_name) &&
                listData[employeeKeys[row.field_name]]
              ) {
                aswerFileds[row.id] = listData[employeeKeys[row.field_name]];
              }
            });
            setAnswerData({ ...answerData, ...aswerFileds });
            setUserData({ ...userData, ...aswerFileds });
          }
        })

        .catch((err) => {});
    }
    // }
  };
  // console.log("answerData", answerData)
  useEffect(() => {
    // setLoading(true);
    getData();
  }, [empValue, empInputValue]);
  const getDetail = () => {
    setLoading(true);

    const params = {
      employee_id: empValue.id,
    };
    DataService.getDirectData(`/coaching_request_forms/employee_detail`, params)
      .then((response) => {
        if (empInputValue) {
          let listData = response.employee_detail;
          setEmpDetail(listData);
          setLoading(false);
          let aswerFileds = {};
          aswerFileds[inputStateVal] =
            empValue.id !== undefined ? empValue.id.toString() : empValue.id;
          CoachinRequest?.filter(
            (selected_field) => selected_field.section_name !== "Description"
          )[value].crf_fields.map((row) => {
            if (
              Object.keys(employeeKeys).includes(row.field_name) &&
              listData[employeeKeys[row.field_name]]
            ) {
              aswerFileds[row.id] = listData[employeeKeys[row.field_name]];
            }
          });
          setAnswerData({ ...answerData, ...aswerFileds });
          setUserData({ ...userData, ...aswerFileds });
        }
      })

      .catch((err) => {});
    // }
  };
  useEffect(() => {
    if (
      empDetail &&
      Object.keys(empDetail).length &&
      Object.keys(CoachinRequest).length
    ) {
      let aswerFileds = {};
      // alert ("hi")
      CoachinRequest.length > 0 &&
        CoachinRequest[value].crf_fields.map((row) => {
          if (
            Object.keys(employeeKeys).includes(row.field_name) &&
            empDetail[employeeKeys[row.field_name]]
          ) {
            aswerFileds[row.id] = empDetail[employeeKeys[row.field_name]];
          }
        });
      setAnswerData({ ...answerData, ...aswerFileds });
      setUserData({ ...userData, ...aswerFileds });
    }
  }, [value, empValue, empInputValue]);

  // console.log('empValueempValue :>> ', empValue, typeof empValue);
  //   useEffect(() => {
  //     setLoading(true);
  //     if(empValue.id !== "" || empValue.id !== null || empValue.id !== undefined || empValue.id !== "" || empValue.id !== null || empValue.id !== undefined){
  //     getDetail();
  //     }
  //   }, [empValue, empInputValue]);

  const handleSubmit = () => {
    setLoading(true);
    let aswerFileds = {};

    // console.log('empValue.id.', empValue.full_name)
    aswerFileds[inputStateVal] =
      empValue.id !== undefined ? empValue.id.toString() : empValue.id;

    CoachinRequest?.filter(
      (selected_field) => selected_field.section_name !== "Description"
    )[value].crf_fields.map((row) => {
      if (
        Object.keys(employeeKeys).includes(row.field_value) &&
        empData[employeeKeys[row.field_value]]
      ) {
        aswerFileds[row.id] = empData[employeeKeys[row.field_value]];
      }
    });
    setAnswerData({ ...answerData, ...aswerFileds });
    setUserData({ ...userData, ...aswerFileds });
    for (var i in answerData) {
      if (i !== "null") {
        quesArr.push({ crf_field_id: i, value: answerData[i] });
      }
    }
    let section_name = CoachinRequest.section_name;
    const statusData = {
      coaching_request_form_id: crfFromId,
      crf_form_section_id: sectionId,
      crf_answers: JSON.stringify(quesArr),
      crf_user_id: crfUserId || "",
      approval_status:
        value + 2 === CoachinRequest.length ? "Pending review by acuity" : "",
    };
    DataService.createData(statusData, "crf_answers")
      .then((res) => {
        // CrfFetch();

        const nameOfCoach =
          empValue.id !== undefined
            ? empValue.full_name.toString()
            : empValue.full_name;
        // if (res.success) {
        if (res.coaching_request_form) {
          let crfUserId = res.coaching_request_form.crf_user_id;

          setCrfUserId(crfUserId);
          setLoading(false);
          if (value + 1 < CoachinRequest.length) {
            setValue(value + 1);
            dispatch(showSnackbar("success", ["Success!"]));
          }
          console.log(
            "crfUserId :>> ",
            crfUserId,
            CoachinRequest.length,
            res.coaching_request_form.crf_user_id
          );
          if (res.coaching_request_form.crf_user_id) {
            const statusData = {
              coaching_request_form_id: crfFromId,
              crf_user_id: crfUserId || "",
            };

            DataService.getDirectData(`/crf_users/view_crf`, statusData).then(
              (res) => {
                // if(res.success){
                let crfAnswer = res;
                let CoachinRequests =
                  res.coaching_request_form.crf_form_sections;

                setCrfSection(CoachinRequests);
              }
            );
          }
          // dispatch(showSnackbar("success", ["Success!"]));
          if (value + 2 === CoachinRequest.length) {
            history.push({
              pathname: `/acknowledgement`,
              state: { nameOfCoach: nameOfCoach },
            });
            // localStorage.clear();
          }
        } else {
          dispatch(showSnackbar("Error", [res?.message]));
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(`error`, error);
        setLoading(false);
        dispatch(showSnackbar("Error", [error.errors]));
      });
  };
  return (
    <div>
      <div class="parent">
        <img src={BannerImage} class="image1" alt={BannerImage} width="100%" />
        <img
          class="image2"
          src={orgLogo.length !== 0 && orgLogo.document.url}
          alt="logo"
        />
        <span class="image4">Program Name - {prgName}</span>
      </div>
      <div className={classes.root}>
        <Paper elevation={3} style={{ marginLeft: "11%", width: "80.6%" }}>
          <div className={classes.demo1}>
            <div class="" style={{ padding: "20px" }}>
              {crfDescription}
            </div>
            <Tabs
              value={value}
              variant="scrollable"
              scrollButtons="auto"
              onChange={handleChange}
              classes={{ root: classes.tabRoot }}
            >
              {CoachinRequest.length > 0 &&
                CoachinRequest?.filter(
                  (selected_field) =>
                    selected_field.section_name !== "Description"
                ).map((item1, index) => {
                  return (
                    // <Tab classes={{ root: classes.tabs }} label={item.section_name} />

                    <Tab
                      label={item1.section_name}
                      classes={{ root: classes.tabs }}
                      {...a11yProps(index, item1)}
                      style={{ textTransform: "initial" }}
                    />
                  );
                })}
            </Tabs>
          </div>

          {CoachinRequest.length > 0 &&
            CoachinRequest?.filter(
              (selected_field) => selected_field.section_name !== "Description"
            ).map((item1, index) => {
              return (
                <TabPanel className={classes.demo2} value={value} index={index}>
                  {CoachinRequest.length > 0 &&
                    CoachinRequest?.filter(
                      (selected_field) =>
                        selected_field.section_name !== "Description"
                    )[index].crf_fields.map((row) => (
                      <Grid
                        container
                        direction="row"
                        alignItems="flex-start"
                        style={{ marginBottom: 20 }}
                      >
                        <Grid
                          item
                          xs={
                            row.field_value === "Description"
                              ? 10
                              : row.field_type === "text area" ||
                                row.field_type === "Text area"
                              ? 12
                              : 5
                          }
                        >
                          <InputLabel
                            className={classes.labelText}
                            style={{
                              marginTop: "20px",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {row.field_value === "Description"
                              ? row.description
                              : row.field_value === "Is approval required"
                              ? " "
                              : row.field_value}
                          </InputLabel>
                        </Grid>
                        {row.field_value !== "Description" && (
                          <Grid
                            item
                            style={{
                              paddingTop:
                                row.field_type === "text area" ||
                                row.field_type === "Text area"
                                  ? "20px"
                                  : "",
                            }}
                            xs={
                              row.field_type === "text area" ||
                              row.field_type === "Text area"
                                ? 9
                                : 4
                            }
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              style={{ marginBottom: 20 }}
                            >
                              <Grid item xs={12}>
                                {(row.field_type === "text" ||
                                  row.field_type === "Text") &&
                                  // row.field_value !== "Name" &&
                                  // row.field_value !== "Email address" &&
                                  // row.field_value !== "Mobile" &&
                                  // row.field_value !== "Telephone" &&
                                  // row.field_value !== "Grade" &&
                                  // row.field_value !==
                                  //   "HR sponsor contact details" &&
                                  // row.field_value !== "HR sponsor name" &&
                                  // row.field_value !== "HR sponsor title" &&
                                  // row.field_value !== "LOB leader name" &&
                                  // row.field_value !==
                                  //   "Line manager PA contact details" &&
                                  // row.field_value !== "Line manager PA name" &&
                                  // row.field_value !== "Band" &&
                                  // row.field_value !== "Office city" &&
                                  // row.field_value !== "Home city" &&
                                  // row.field_value !== "Office country" &&
                                  // row.field_value !== "Home country" &&
                                  // row.field_value !== "PA Name" &&
                                  // row.field_value !== "Role" &&
                                  // row.field_value !== "Line manager name" &&
                                  // row.field_value !== "Name of Line Manager" &&
                                  // row.field_value !==
                                  //   "Line manager contact details" &&
                                  // row.field_value !== "Line manager title" &&
                                  // row.field_value !== "LOB leader" &&
                                  // row.field_value !== "Job Title" &&
                                  // row.field_value !== "Job title" &&
                                  // row.field_value !== "Level" &&
                                  // row.field_value !== "PA contact details" &&
                                  // row.field_value !== "Level" &&
                                  row.field_name !== "coahee_name" &&
                                  row.field_name !==
                                    "line_manager_email_address" &&
                                  row.field_name !== "contact_details_email" &&
                                  row.field_name !== "line_manager_name" &&
                                  row.field_name !== "role" &&
                                  row.field_name !== "location" &&
                                  row.field_name !== "home_based_location" &&
                                  row.field_name !== "name_of_people_partner" &&
                                  row.field_name !==
                                    "people_partner_email_address" &&
                                  row.field_name !==
                                    "human_capital_partner_email_address" &&
                                  // row.field_value !== "HR sponsor title" &&
                                  row.field_name !== "lob_leader" &&
                                  row.field_name !== "pa_email_address" &&
                                  // row.field_value !== "LOB leader" &&
                                  // row.field_name !== "line_manager_telephone" &&
                                  row.field_name !==
                                    "contact_details_phone_number" &&
                                  row.field_name !==
                                    "contact_details_telephone_number" &&
                                  row.field_name !== "coahee_job_tittle" &&
                                  row.field_name !== "pa_name" &&
                                  row.field_name !==
                                    "name_of_human_capital_partner" &&
                                  // row.field_name !== "band" &&
                                  row.field_name !== "level" && (
                                    <CustomInput
                                      defaultValue={row.answer}
                                      id={row.id}
                                      variant="outlined"
                                      placeholder={row.field_value}
                                      parentcall={setInputState}
                                    />
                                  )}
                                {row.field_name === "coahee_name" && (
                                  <Autocomplete
                                    value={empValue}
                                    onChange={(event, newValue) => {
                                      if (newValue === null) {
                                        //Just give a value to a value to avoid null
                                        //e.g. value = ""
                                        newValue = "";
                                      }
                                      setEmpValue(newValue);
                                      setInputStateVal(row.id);
                                    }}
                                    size={"medium"}
                                    inputValue={empInputValue}
                                    onInputChange={(event, newInputValue) => {
                                      setEmpInputValue(newInputValue);
                                    }}
                                    classes={{
                                      input: classes.autoComplete,
                                      option: classes.autoComplete,
                                    }}
                                    id={row.id}
                                    options={empData}
                                    getOptionLabel={(option) =>
                                      option.full_name
                                    }
                                    // style={{ width: 280, fontSize: "16px" }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        classes={{
                                          root: classes.customTextField,
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          style: { fontSize: "16px" },
                                        }}
                                        placeholder="Employee name"
                                        // autoFocus
                                        variant="outlined"
                                      />
                                    )}
                                  />
                                )}
                                {empDetail !== undefined &&
                                  empValue !== null && (
                                    <React.Fragment>
                                      {row.field_name ===
                                        "line_manager_email_address" && (
                                        <div
                                          key={
                                            empDetail.line_manager_contact_details
                                          }
                                        >
                                          <CustomInput
                                            // defaultValue={row.answer === null
                                            //   ? empDetail.primary_email
                                            //   : row.answer}
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.line_manager_contact_details
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.line_manager_contact_details === row.answer ? row.answer : empDetail.line_manager_contact_details}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "contact_details_email" && (
                                        <div key={empDetail.primary_email}>
                                          <CustomInput
                                            // defaultValue={row.answer === null
                                            //   ? empDetail.primary_email
                                            //   : row.answer}
                                            defaultValue={
                                              empDetail.primary_email ===
                                              row.answer
                                                ? row.answer
                                                : empDetail.primary_email
                                            }
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "name_of_human_capital_partner" && (
                                        <div key={empDetail.hr_sponsor_name}>
                                          <CustomInput
                                            // defaultValue={row.answer === null
                                            //   ? empDetail.primary_email
                                            //   : row.answer}
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.hr_sponsor_name
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.hr_sponsor_contact_details === row.answer ? row.answer : empDetail.hr_sponsor_contact_details}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "human_capital_partner_email_address" && (
                                        <div
                                          key={
                                            empDetail.hr_sponsor_contact_details
                                          }
                                        >
                                          <CustomInput
                                            // defaultValue={row.answer === null
                                            //   ? empDetail.primary_email
                                            //   : row.answer}
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.hr_sponsor_contact_details
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.hr_sponsor_contact_details === row.answer ? row.answer : empDetail.hr_sponsor_contact_details}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "name_of_people_partner" && (
                                        <div key={empDetail.hr_sponsor_name}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.home_city
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.hr_sponsor_name
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.hr_sponsor_name === row.answer ? empDetail.home_city : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "people_partner_email_address" && (
                                        <div
                                          key={
                                            empDetail.hr_sponsor_contact_details
                                          }
                                        >
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.home_city
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.hr_sponsor_contact_details
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.hr_sponsor_name === row.answer ? empDetail.home_city : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {/* {row.field_value === "People partner email address" && (
                                      <div key={empDetail.people_partner_email_address}>

                                        <CustomInput

                                          // defaultValue={row.answer === null
                                          //   ? empDetail.primary_email
                                          //   : row.answer}
                                          defaultValue={empDetail.people_partner_email_address === row.answer ? row.answer : empDetail.people_partner_email_address}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )}  
                                     {row.field_value === "Human capital partner email address" && (
                                      <div key={empDetail.human_capital_partner_email_address}>

                                        <CustomInput

                                          // defaultValue={row.answer === null
                                          //   ? empDetail.primary_email
                                          //   : row.answer}
                                          defaultValue={empDetail.human_capital_partner_email_address === row.answer ? row.answer : empDetail.human_capital_partner_email_address}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )}   
                                                        
                                    {row.field_value === "Line manager email address" && (
                                      <div key={empDetail.line_manager_email_address}>

                                        <CustomInput

                                          // defaultValue={row.answer === null
                                          //   ? empDetail.primary_email
                                          //   : row.answer}
                                          defaultValue={empDetail.line_manager_email_address === row.answer ? row.answer : empDetail.line_manager_email_address}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {(row.field_name ===
                                      "home_based_location") && (
                                        <div key={empDetail.home_city}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.home_city
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.home_city === row.answer ? empDetail.home_city : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                      {/* {(row.field_value ===
                                      "Home country") && (
                                        <div key={empDetail.home_country}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.home_country
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.home_country === row.answer ? empDetail.home_country : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                      {/* {(row.field_value ===
                                      "Office country") && (
                                        <div key={empDetail.office_country}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.office_country
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.office_country === row.answer ? empDetail.office_country : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                      {/* {row.field_name === "location" && (
                                      <div key={empDetail.office_city}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.office_city
                                          //     : row.answer
                                          // }
                                          defaultValue={
                                            row.answer === null
                                              ? empDetail.office_city
                                              : row.answer
                                          }
                                          // defaultValue={empDetail.office_city === row.answer ? empDetail.office_city : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {row.field_name === "location" && (
                                        <div key={empDetail.office_address}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.office_city
                                            //     : row.answer
                                            // }
                                            // defaultValue={empDetail.office_address === row.answer ? empDetail.office_address : row.answer}
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.office_address
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.office_address ? empDetail.office_address : row.answer ===empDetail.office_address ? row.answer  : empDetail.office_address}
                                            // defaultValue={empDetail.office_city }
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "line_manager_name" && (
                                        <div key={empDetail.line_manager_name}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.line_manager_name
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.line_manager_name
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.line_manager_name === row.answer ? empDetail.line_manager_name : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}

                                      {row.field_name === "role" && (
                                        <div key={empDetail.job_role}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.job_role
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.job_role
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.job_role === row.answer ? empDetail.job_role : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {/* {(row.field_value === "Line manager PA name") && (
                                      <div key={empDetail.line_manager_pa_name}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.line_manager_pa_name
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.line_manager_pa_name === row.answer ? empDetail.line_manager_pa_name : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {row.field_value ===
                                      "Name of Line Manager" && (
                                      <div key={empDetail.home_country}>
                                        <CustomInput
                                          defaultValue={
                                            empValue.home_country ===
                                            row.answer
                                              ? row.answer
                                              : empDetail.home_country
                                          }
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {(row.field_value === "HR sponsor title") && (
                                      <div key={empDetail.hr_sponsor_title}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.hr_sponsor_title
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.hr_sponsor_title === row.answer ? empDetail.hr_sponsor_title : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {row.field_name === "lob_leader" && (
                                        <div key={empDetail.lob_leader_name}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.lob_leader_name
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.lob_leader_name
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.lob_leader_name === row.answer ? empDetail.lob_leader_name : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {/* {(row.field_value === "Line manager PA contact details") && (
                                      <div key={empDetail.line_manager_pa_contact_details}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.line_manager_pa_contact_details
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.line_manager_pa_contact_details === row.answer ? empDetail.line_manager_pa_contact_details : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {(row.field_name === "department") && (
                                      <div key={empDetail.department}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.hr_sponsor_contact_details
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.department === row.answer ? empDetail.department : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {row.field_name ===
                                      "line_manager_name" && (
                                        <div key={empDetail.line_manager_title}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.line_manager_title
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.line_manager_title === row.answer ? empDetail.line_manager_title : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                      {/* {row.field_value ===
                                      "Line manager contact details" && (
                                        <div key={empDetail.line_manager_contact_details}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.line_manager_contact_details
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.line_manager_contact_details === row.answer ? empDetail.line_manager_contact_details : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}

                                      {row.field_name ===
                                        "pa_email_address" && (
                                        <div key={empDetail.pa_contact_details}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.pa_contact_details
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.pa_contact_details
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.pa_contact_details === row.answer ? empDetail.pa_contact_details : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {/* {row.field_value === "LOB leader" && (
                                      <div key={empDetail.lob_leader}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.lob_leader
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.lob_leader === row.answer ? empDetail.lob_leader : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}

                                      {row.field_name ===
                                        "contact_details_telephone_number" && (
                                        <div key={empDetail.telephone}>
                                          {console.log(
                                            "telephone",
                                            empDetail.telephone
                                          )}
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.mobile
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.telephone
                                                : row.answer
                                            }
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name ===
                                        "contact_details_phone_number" && (
                                        <div key={empDetail.mobile}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.mobile
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.mobile
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.mobile === row.answer ? empDetail.mobile : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}

                                      {row.field_name ===
                                        "coahee_job_tittle" && (
                                        <div key={empDetail.job_title}>
                                          <CustomInput
                                            // defaultValue={empValue.full_name === row.answer ? empDetail.job_title :  row.answer}
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.job_title
                                                : row.answer
                                            }
                                            id={row.id}
                                            // defaultValue={empDetail.job_title === row.answer ? empDetail.job_title : row.answer}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {/* {(row.field_value === "Job Title") && (
                                      <div key={empDetail.job_title}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.job_title
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.job_title === row.answer ? row.answer : empDetail.job_title}
                                          // defaultValue={empDetail.job_title === row.answer ?  empDetail.job_title : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {row.field_value === "Telephone" && (
                                      <div key={empDetail.telephone}>
                                        <CustomInput
                                          // defaultValue={ empDetail.telephone}
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.telephone
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.telephone === row.answer ? empDetail.telephone : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {row.field_name ===
                                        "home_based_location" && (
                                        <div key={empDetail.home_address}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.home_city
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              empDetail.home_address ===
                                              row.answer
                                                ? empDetail.home_address
                                                : row.answer
                                            }
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {row.field_name === "pa_name" && (
                                        <div key={empDetail.pa_name}>
                                          <CustomInput
                                            // defaultValue={ empDetail.pa_name}
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.pa_name
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.pa_name
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.pa_name === row.answer ? empDetail.pa_name : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}

                                      {row.field_name === "level" && (
                                        <div key={empDetail.level_or_grade}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.level_or_grade
                                            //     : row.answer
                                            // }
                                            defaultValue={
                                              row.answer === null
                                                ? empDetail.level_or_grade
                                                : row.answer
                                            }
                                            // defaultValue={empDetail.level_or_grade === row.answer ? empDetail.level_or_grade : row.answer}
                                            // defaultValue={empDetail.level_or_grade}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )}
                                      {/* {row.field_name === "band" && (
                                      <div key={empDetail.level_or_grade}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.level_or_grade
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.level_or_grade === row.answer ? empDetail.level_or_grade : row.answer}
                                          // defaultValue={empDetail.level_or_grade}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      {/* {row.field_value === "Grade" && (
                                      <div key={empDetail.level_or_grade}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.level_or_grade
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.level_or_grade === row.answer ? empDetail.level_or_grade : row.answer}
                                          // defaultValue={empDetail.level_or_grade}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                    </React.Fragment>
                                  )}

                                {(row.field_type === "text area" ||
                                  row.field_type === "Text area") && (
                                  <CustomInput
                                    multiline
                                    rows="4"
                                    id={row.id}
                                    defaultValue={row.answer}
                                    //   id={crf_answers}
                                    variant="outlined"
                                    parentcall={setInputState}
                                  />
                                )}

                                {(row.field_type === "dropdown" ||
                                  row.field_type === "Drop down") &&
                                (row.field_value === "Programme Name" ||
                                  row.field_value === "Program Name" ||
                                  row.field_value === "Program name" ||
                                  row.field_value === "Programme name") ? (
                                  <CustomInput
                                    // id={row.id}

                                    disabled
                                    defaultValue={prgName}
                                    value={prgName}
                                    //   id={crf_answers}
                                    variant="outlined"
                                    // parentcall={setInputState}
                                  />
                                ) : (
                                  (row.field_type === "dropdown" ||
                                    row.field_type === "Drop down") && (
                                    <CustomSelect
                                      id={row.id}
                                      displayEmpty
                                      variant="outlined"
                                      labelText="Select a value"
                                      defaultValue={row.answer}
                                      itemArr={row.option}
                                      parentcall={setQuestionChangeState}
                                    />
                                  )
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        <Grid item xs={0}></Grid>
                        <Grid item xs={2}></Grid>
                        {row.field_value === "Is approval required" && (
                          <React.Fragment>
                            {" "}
                            <Grid item xs={5}>
                              <InputLabel
                                className={classes.labelText}
                                style={{ marginTop: 7 }}
                              >
                                Is approval required
                              </InputLabel>
                            </Grid>
                            <Grid item xs={6}>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  row
                                  aria-label="item"
                                  defaultValue={radioValue}
                                  name="approval_required"
                                  onChange={handleradioChange}
                                >
                                  <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Yes"
                                  />
                                  <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </React.Fragment>
                        )}
                      </Grid>
                    ))}
                  <Grid
                    container
                    direction="row"
                    alignItems="flex-start"
                  ></Grid>
                </TabPanel>
              );
            })}
          <Grid container direction="row" alignItems="flex-start">
            <Grid item xs={10}></Grid>
            <Grid item xs={2}>
              <div className={classes.stepperButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  variant="contained"
                  // color="primary"
                  style={{ background: "#EF7000", color: "white" }}
                  className={classes.btnSearch}
                  onClick={handleSubmit}
                >
                  {loading && (
                    <CircularProgress
                      className={classes.circularProgress}
                      size={20}
                    />
                  )}
                  {value + 2 === CoachinRequest.length ? "Submit" : "Save"}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
      <div></div>
    </div>
  );
}
